/** Canonical pin ordering; mirrored byte-for-byte in web/lib/pinOrder.ts. */
export function pinnedConversationComparator(pinOrder: readonly string[]) {
  const rank = new Map(pinOrder.map((id, index) => [id, index]));
  return (a: { id: string; pinnedAt: string | null }, b: { id: string; pinnedAt: string | null }): number => {
    if (a.pinnedAt === null || b.pinnedAt === null) return Number(b.pinnedAt !== null) - Number(a.pinnedAt !== null);
    const rankA = rank.get(a.id);
    const rankB = rank.get(b.id);
    if (rankA !== undefined && rankB !== undefined) return rankA - rankB;
    if (rankA !== undefined) return 1;
    if (rankB !== undefined) return -1;
    return b.pinnedAt.localeCompare(a.pinnedAt) || a.id.localeCompare(b.id);
  };
}
